import { useQuery, UseQueryResult } from 'react-query';
import { ReadingListDto } from '../../services/dtos/readingList/readingList.dto';
import { fetchReadingList } from '../../services/readingList/readingList.service';
import { queryKeys } from '../queryKeyFactory';

interface UseFetchReadingListsOptions {
  enabled?: boolean;
}

export default ({ enabled = true }: UseFetchReadingListsOptions = {}): UseQueryResult<
  ReadingListDto[] | undefined,
  Error
> =>
  useQuery<ReadingListDto[] | undefined, Error>(
    [queryKeys.fetchReadingLists.all],
    async () => {
      return fetchReadingList();
    },
    { enabled }
  );
